import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { Grid, Card, CardContent, Typography, Avatar } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

// import { Line } from 'react-chartjs-2'

import moment from 'moment'

// const lineChartConfig = {
//   labels: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
//   datasets: [{
//     data: [589, 445, 483, 503, 689, 692, 634],
//     backgroundColor: 'transparent',
//     borderColor: '#007bff',
//     borderWidth: 4,
//     padding: 4,
//     pointBackgroundColor: '#007bff',
//     label: 'Number of Uses',
//     lineTension: 0
//   }]
// }

const useStyles = makeStyles((theme) => ({
  countAvatar: {
    width: 'fit-content',
    backgroundColor: '#3984f7',
    color: '#fff',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(2)
  },
  chartPaper: {
    padding: theme.spacing(1.5),
    height: '100%',
    width: '100%'
  },
  workstationTitle: {
    fontWeight: 'bold',
    color: '#777777',
    marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(2)
  },
  activeAvatar: {
    backgroundColor: '#3984f7',
    color: '#fff',
    width: 'fit-content',
    padding: theme.spacing(1)
  }
}))

/**
 * Chart is currently built using react-chartjs-2, a react wrapper for ChartJS2
 * https://github.com/jerairrest/react-chartjs-2
 * https://www.npmjs.com/package/react-chartjs-2
 * */

/**
 * Chart was originally built using chart.js: https://www.chartjs.org/
 * modified with hooks: https://dev.to/vcanales/using-chart-js-in-a-function-component-with-react-hooks-246l
 * https://codesandbox.io/s/hopeful-kalam-phzdt?file=/src/App.js:93-161
 * */

const OrganizationLicense = () => {
  const classes = useStyles()

  const settings = useSelector(state => state.orgLicense.general)
  const license = {
    maxUserCount: settings.maxUserCount,
    activeUserCount: settings.activeUserCount,
    beginsAt: settings.beginsAt,
    expiresAt: settings.expiresAt,
    createdAt: settings.createdAt
  }
  const [licenseInfo] = useState(license)
  const [licenseData, setLicenseData] = useState({ total: 3000, inUse: 2678 })
  const [licenseDate, setLicenseDate] = useState({ startDate: 'August 18, 2020', endDate: 'August 17, 2021' })

  useEffect(() => {
    setLicenseData(licenseData)
    setLicenseDate(licenseDate)
  }, [setLicenseDate, licenseDate, setLicenseData, licenseData])

  return (
    <Grid container direction='row'>
      <Grid container item direction='column' spacing={2} className='m-auto'>

        <Grid container item direction='row'>
          <h2>Account Licenses</h2>
        </Grid>

        <Grid container item direction='row'>
          <Card className='w-100 mx-auto'>
            <CardContent>
              <Grid container direction='row'>
                <Grid container direction='column' item xs={5}>
                  <Grid item container direction='row' className='mb-2'>
                    <Typography variant='h5'>Total Device Licenses:</Typography>
                  </Grid>

                  <Grid item container direction='row' spacing={2} className='w-100 mx-auto'>

                    <Grid item className='pl-0'>
                      <Grid container direction='row' spacing={1} className='mx-auto px-0' alignItems='center'>
                        <Grid item className='pl-0'>
                          <Avatar variant='rounded' className={classes.countAvatar}>
                            <Typography className='font-weight-bold'>{licenseInfo.maxUserCount}</Typography>
                          </Avatar>
                        </Grid>

                        <Grid item>
                          <Typography>Total</Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item>
                      <Grid container direction='row' justify='center' alignItems='center'>
                        <Typography variant='h6' className='font-weight-bold'>/</Typography>
                      </Grid>
                    </Grid>

                    <Grid item>
                      <Grid item container direction='row' spacing={1} className='mx-auto' alignItems='center'>
                        <Grid item>
                          <Avatar variant='rounded' className={classes.countAvatar}>
                            <Typography className='font-weight-bold'>{licenseInfo.activeUserCount}</Typography>
                          </Avatar>
                        </Grid>

                        <Grid item>
                          <Typography>In Use</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                </Grid>

                <Grid container direction='column' item xs={5}>
                  <Grid item container direction='row' className='mb-2'>
                    <Typography variant='h5'>License Active Period:</Typography>
                  </Grid>

                  <Grid item container direction='row' spacing={2} className='w-100 m-auto'>
                    <Typography>{moment(licenseInfo.beginsAt).format('MM/DD/YYYY')} - {moment(licenseInfo.expiresAt).format('MM/DD/YYYY')}</Typography>
                  </Grid>
                </Grid>

                <Grid container direction='row' item xs={2} alignItems='center' justify='center'>
                  <Avatar variant='rounded' className={classes.activeAvatar}>
                    <Typography variant='h6' className='font-weight-bold'>ACTIVE</Typography>
                  </Avatar>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* <Grid container item direction='row'>
          <Paper elevation={2} className={classes.chartPaper}>
            <h4 className={`unselectable ${classes.workstationTitle}`}>Workstation Usage By Day</h4>
            <Line
              data={lineChartConfig}
              // width={100}
              height={200}
              options={{
                // responsive: true,
                // maintainAspectRatio: false,
                legend: { position: 'bottom' }
              }}
            />
          </Paper>
        </Grid> */}

      </Grid>
    </Grid>
  )
}

export default OrganizationLicense
